import { render, staticRenderFns } from "./FourOhFour.vue?vue&type=template&id=2deac910&scoped=true&"
import script from "./FourOhFour.vue?vue&type=script&lang=js&"
export * from "./FourOhFour.vue?vue&type=script&lang=js&"
import style0 from "./FourOhFour.vue?vue&type=style&index=0&id=2deac910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deac910",
  null
  
)

export default component.exports